"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));
var _FormLabel = _interopRequireDefault(require("@material-ui/core/FormLabel"));
var _RadioGroup = _interopRequireDefault(require("@material-ui/core/RadioGroup"));
var _constants = require("../constants");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var RadioGroupHeading = _styledComponents["default"].div.withConfig({
  displayName: "radio_group__RadioGroupHeading"
})(["font-family:'Untitled Sans',sans-serif;", ";font-size:12px;color:", ";margin-bottom:2px;"], (0, _constants.fontWeight)('normal'), _constants.colors.darkGrey);
var RadioGroupContainer = _styledComponents["default"].div.withConfig({
  displayName: "radio_group__RadioGroupContainer"
})(["margin:14px 0;"]);
function RadioGroup(props) {
  return /*#__PURE__*/React.createElement(_FormControl["default"], {
    component: "fieldset"
  }, props.title && /*#__PURE__*/React.createElement(_FormLabel["default"], {
    component: "legend"
  }, /*#__PURE__*/React.createElement(RadioGroupHeading, null, props.title)), /*#__PURE__*/React.createElement(RadioGroupContainer, null, /*#__PURE__*/React.createElement(_RadioGroup["default"], {
    "aria-label": props.name,
    name: props.name,
    value: props.value,
    onChange: props.onChange
  }, props.children)));
}
var _default = RadioGroup;
exports["default"] = _default;